module.exports = __webpack_public_path__ + "media/images/countryrect/mk-57865d848f3bbcbbece3915b325e596a.svg";